import { Amex, Discover, MasterCard, NoName, Visa } from "./icons";

export const getPaymentMethodIconByCardType = (cardType: string | null | undefined) => {
  switch (cardType) {
    case "mastercard": return <MasterCard />;
    case "visa": return <Visa />;
    case "discover": return <Discover />;
    case "amex": return <Amex />;
    default: return <NoName />
  }
}
export const formattingCardNumber = (value: string | undefined, gaps: number[]) => {
  return value?.split("")
    .map((x, i) => gaps.includes(i + 1) ? `${x} ` : x)
    .join("")
    .trimEnd();
}
